import React from "react";
import { Box, Button, Typography } from "@mui/material";
import ModalWrapper from "../ModalWrapper/ModalWrapper";
import { useTranslation } from "react-i18next";

const ComplianceDescriptionModal = ({ open, setOpen, document }) => {
	const { t } = useTranslation();
	if (!document) return null;

	return (
		<ModalWrapper
			open={open}
			setOpen={setOpen}
			title={document.title || t("LABELS.DOCUMENT")}
			subtitle={
				document.version_label
					? `${t("LABELS.VERSION")}: ${document.version_label}`
					: document.doc_type
			}
			content={
				document.description_html ? (
					<Box
						sx={{ "& p": { mb: 1 }, fontSize: "0.95rem" }}
						dangerouslySetInnerHTML={{ __html: document.description_html }}
					/>
				) : (
					<Typography variant="body2">
						{document.description_text || t("UI_TEXT.NO_DESCRIPTION_AVAILABLE")}
					</Typography>
				)
			}
			actions={
				<Button onClick={() => setOpen(false)} variant="contained">
					{t("BUTTON.CLOSE")}
				</Button>
			}
		/>
	);
};

export default ComplianceDescriptionModal;
